import TextComponent from "Component/Render/Text";
import { EventLayoutMap } from "Constants/Events/EventLayoutMap";
import { EVENT_OFFERS } from "Constants/Shop";
import Game from "Game";
import { report } from "report";
import { IGameState } from "State/Game/IGameState";
import { IAPStateHelper } from "State/Player/IAP/IAPStateHelper";
import { PopupID } from "State/UI/PopupID";
import Timer from "System/Timer/Timers/Timer";
import { ArrayHelper } from "Utility/ArrayHelper";
import { cached } from "Utility/async";
import DateHelper from "Utility/DateHelper";
import { EventType } from "Utility/Helpers/Events/EventType";
import { PopupOfferType, PopupOfferTypeMap } from "Utility/Helpers/IAP/PopupOffers";
import { ProductId } from "Utility/Product";
import { EventStateHelper } from "./EventStateHelper";
import { IEventStateData } from "./IEventsState";
import getActiveEvents = EventStateHelper.getActiveEvents;

// TODO: Cache this for each type
export function eventHasQuest(eventType: EventType): boolean {
    return Game.resource.existsOrQueued(getEventQuestsKey(eventType));
}

export function getEventQuestsKey(eventType: EventType): string {
    return `${eventType}_quests`;
}

export function getEventQuestsPath(eventType: EventType): string {
    return `resource/data/events/${eventType}/quests.json`;
}

export function queueEventOfferAssets(): void {
    const state = Game.store.getState();
    const eventWithAvailableOffer = IAPStateHelper.getHighestPrioEventWithAvailableOffer(state);
    EVENT_OFFERS[eventWithAvailableOffer.type].queueAssets();
}


export function isEventType(data: unknown): data is EventType {
    return CACHED_EVENT_TYPES().includes(
        data as EventType
    );
}

// TODO: Refactor to get layouts by LayoutId
/**
 * Gets layout for highest prio event that overrides the given popupId
 */
export function getActiveEventLayout(popupId: PopupID) {
    const state = Game.store.getState();
    const validEvent = ArrayHelper.sortByHighestPriority(getActiveEvents(state)).find(
        // @ts-ignore
        event => EventLayoutMap[event.type]?.[popupId]
    );

    if (validEvent && EventLayoutMap[validEvent.type] && EventLayoutMap[validEvent.type][popupId]) {
        return getEventLayout(validEvent.type, popupId)
    }
}

function getEventLayout<ET extends EventType, PI extends PopupID>(eventType: ET, popupId: PI): (typeof EventLayoutMap)[ET][PI] {
    return new EventLayoutMap[eventType][popupId]();
}

export function getEventOfferProductId(eventType: EventType): ProductId {
    return PopupOfferTypeMap[PopupOfferType.EVENT_OFFER][eventType];
}

export function getEventOfferButtonCacheKey(eventType: EventType): string {
    return `${eventType}-button`
}

export function createEventOfferTimer(state: IGameState, eventType: EventType, textComponent: TextComponent, options?: { onComplete: (state: IGameState) => void}): Timer {
    const timer = new Timer(false);

    const eventState = EventStateHelper.getEventState(state, eventType);

    if (!eventState) {
        report("Failed to find active event when creating an event timer", {
            once: true,
            sampleRate: 0.1,
            tags: {
                eventType
            },
            fingerprint: "createEventOfferTimer:NoEventFound",
            state
        })
        return timer;
    }

    const { duration } = eventState;

    // Set up timing
    timer.duration = duration;
    timer.getDate = (state: IGameState) => {
        const eventState = EventStateHelper.getEventState(state, eventType);
        if (eventState) {
            return DateHelper.getDate(eventState.startTime);
        }

        return null;
    }

    // Update timer text
    timer.format = "DD:hh:mm:ss"
    timer.onUpdate = (state: IGameState) => {
        if (textComponent && textComponent.gameObject && !textComponent.gameObject.destroyed) {
            textComponent.text = timer.getFormattedCountdown(state);
        }
    }
    timer.onUpdate(state);

    if (options?.onComplete) {
        timer.complete = options.onComplete;
    }

    return timer;
}

export function getAllEvents(): IEventStateData[] {
    const activeEvents: IEventStateData[] = [];

    const config = Game.resource.get<IEventConfig[]>("events");
    config.forEach(config => {
        const startTime = (DateHelper.getDate(config.startTime)).toISOString();

        activeEvents.push({
            ...config,
            startTime
        })
    });

    return activeEvents;
}

export interface IEventConfig {
    type: EventType;
    duration: number;
    startTime: string;
    hasQuests: boolean;
    requiredLevel?: number;
}
const CACHED_EVENT_TYPES = cached<EventType[]>(() => {
    return Object.values(EventType);
});
